import { render, staticRenderFns } from "./MdPriorAuthorization.vue?vue&type=template&id=379862c0&"
import script from "./MdPriorAuthorization.vue?vue&type=script&lang=js&"
export * from "./MdPriorAuthorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports